//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SPage from '~/components/page/SPage.vue'
import QuestionForm from '~/components/question-specialist/QuestionForm.vue'
import QuestionSearch from '~/components/question-specialist/QuestionSearch.vue'
import QuestionAnswerCard from '~/components/question-specialist/QuestionAnswerCard.vue'
import Pagination from '~/components/Pagination.vue'

export default {
  name: 'questions-specialist',

  components: {
    SPage,
    Pagination,

    QuestionForm,
    QuestionSearch,
    QuestionAnswerCard,
  },

  data() {
    return {
      breadcrumbs: [
        {
          path: '/',
          title: 'Главная'
        },
        {
          path: '/questions-specialist',
          title: 'Задать вопрос офтальмологу'
        }
      ],
      tags: [],
      isLoading: true, // загрузка списка вопросов ?
      questions: [],
      pagination: {
        currentPage: 1,
        pageCount: null,
        pageSize: null,
        totalCount: null
      },

      choosingTagFromQuestion: null,
    }
  },
  computed: {
    cmsPageIdFromStore() {
      const cmsId = this.$store.state?.appState?.vars?.['Шаблон для Задать вопрос офтальмологу'] || '';
      if (!cmsId) {
        return null;
      }
      return Number.parseFloat(cmsId);
    }
  },
  methods: {
    // Получение списка вопросов
    getQuestions: async function () {
      this.isLoading = true;
      const getQuestionsResponse = await this.$api.agent.transport.get(`questions-specialist?limit=${this.pagination.pageSize || 10}&page=${this.pagination.currentPage}`)
      .then((res) => {
        this.isLoading = false;
        return res.data;
      })
      .catch((err) => {
        this.isLoading = false;
        console.error(err);
        return {error: err.response};
      });
      if (getQuestionsResponse.error) {
        this.$toast.error('Произошла ошибка при выполнении запроса');
        return
      }
      this.questions = getQuestionsResponse.models;
      this.pagination = getQuestionsResponse.pagination;
    },

    // Получение тегов вопросов
    getTags: async function () {
      const getTagsResponse = await this.$api.agent.transport.get(`question-specialist-tags`)
      .then((res) => {
        return res.data
      })
      .catch(() => {
        return false
      });

      this.tags = getTagsResponse.models;
    },

    // Изменение пагинации (страницы, кол-во на странице и тд)
    onChangePagination: async function ({
      page,
      perPage,
    }) {
      let newPagination = { ...this.pagination }
      newPagination['currentPage'] = page || newPagination.currentPage
      newPagination['pageSize'] = perPage || newPagination.pageSize

      this.pagination = newPagination


      await this.getQuestions()
    },
    useTagFromQuestion: function (id) {
      this.$refs.refQuestionSearch.chooseTag(id);
    },
    searchQuestions: async function(searchBody, accumTags) {
      let body = searchBody
      body.tags = accumTags.join(',')

      const responseSearch = await this.$api.agent.transport.post('questions-specialist/search', body)
        .then((res) => {
          return res.data;
        }).catch(() => {
          return false;
        });
      this.questions = responseSearch.models;
      this.pagination = responseSearch.pagination;
    },

    resetSearch: async function () {
      this.choosingTagFromQuestion = null;
      await this.getQuestions();
    }
  },
  mounted: function() {
    this.getQuestions()
    this.getTags()
  }
}

